import React from "react";
import styled from "styled-components";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
const Main = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const Title = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  font-size: 0.7em;
`;
const SubIcon = styled(FaChevronUp)`
  margin-right: 4px;
  margin-left: 4px;
  left: 3px;
  color: #0adb93;
  font-size: 0.5em;
`;
const SubIconOff = styled(FaChevronDown)`
  margin-right: 4px;
  margin-left: 4px;
  left: 3px;
  color: #db0a41;
  font-size: 0.5em;
`;
const Content = styled.div`
  display: flex;
  height: 100%;
  font-size: 0.8em;
  align-items: center;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
const Footer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  margin-top: auto;
  font-size: 0.7em;
`;
export default function Opta18({
  item,
  player,
  playerOff,
  previewGraphic,
  game,
  team,
}) {
  let player_off = game?.lineup?.home?.find(
    (p) =>
      p.squad?.player?.opta_ID === playerOff?.playerId,
  );
  if (!player_off) {
    player_off = game?.lineup?.away?.find(
      (p) =>
        p.squad?.player?.opta_ID === playerOff?.playerId,
    );
  }
  function preview() {
    previewGraphic("Substitution", {
      players: [player, player_off],
      team: team,
      game: game,
      clock: true,
    });
  }

  return (
    <Main
      onClick={(e) => {
        preview();
      }}
    >
      <Title>Substitution</Title>
      <Content>
        <Row>
          <SubIcon />
          {player?.squad?.shirt_number ??
            player?.squad?.opta_shirt_number}.{" "}
          {player?.squad?.player?.last_name ??
            player?.squad?.player?.opta_last_name}
        </Row>
        <Row>
          <SubIconOff />
          {player_off?.squad?.shirt_number ??
            player_off?.squad?.opta_shirt_number}
          .{" "}
          {player_off?.squad?.player?.last_name ??
            player_off?.squad?.player?.opta_last_name}
        </Row>
      </Content>
      <Footer>
        <div>
          {item.timeMin?.toString().padStart(2, "0") +
            ":" +
            item.timeSec?.toString().padStart(2, "0")}
        </div>
      </Footer>
    </Main>
  );
}
